import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { SplitButton } from 'shared/components/buttons/split';
export function SaveApplyButtons({ loading, disabled, onSave, onApply, }) {
    return (_jsx(SplitButton, { onClick: onSave, label: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C", disabled: loading || disabled, options: [
            {
                label: 'Применить',
                disabled: loading || disabled,
                onClick: onApply,
            },
        ] }));
}
